import {
  Button2,
  EmptyState,
  EmptyStateAction,
  EmptyStateDescription,
  EmptyStateHeader,
  EmptyStateTitle,
} from '@valuecase/ui-components'

const UnoptimisedForCompleteTasksEmptyState = ({
  onSwitchToListView,
  onResetFilters,
}: {
  onSwitchToListView: () => void
  onResetFilters: () => void
}) => {
  return (
    <div className='flex w-full h-[420px] bg-white justify-center align-middle rounded-lg'>
      <EmptyState icon='list' iconSize='small' className='p-4 gap-4'>
        <EmptyStateHeader>
          <EmptyStateTitle>This view is not optimized for completed tasks</EmptyStateTitle>
        </EmptyStateHeader>
        <EmptyStateDescription>
          Reset filters to show all tasks or switch to the list view
        </EmptyStateDescription>
        <div className='flex gap-2'>
          <Button2
            size={'small'}
            variant='plain'
            className='text-primary-s5'
            onClick={onSwitchToListView}
          >
            Switch to list view
          </Button2>

          <EmptyStateAction onClick={onResetFilters}>Reset Filters</EmptyStateAction>
        </div>
      </EmptyState>
    </div>
  )
}
export default UnoptimisedForCompleteTasksEmptyState
